// mds-dojo — dijit/MenuSeparator — FAITHFUL port of references/dijit/MenuSeparator.js.
// A line between two menu items. declare from the faithful runtime; template ?raw.
import declare from '../dojo/_base/declare-runtime'; // declare
import dom from '../dojo/dom'; // dom.setSelectable
import _WidgetBase from './_WidgetBase';
import _TemplatedMixin from './_TemplatedMixin';
import _Contained from './_Contained';
import template from './templates/MenuSeparator.html?raw';

export default declare('dijit.MenuSeparator', [_WidgetBase, _TemplatedMixin, _Contained], {
  // summary:
  //		A line between two menu items

  templateString: template,

  buildRendering: function () {
    this.inherited(arguments);
    dom.setSelectable(this.domNode, false);
  },

  isFocusable: function () {
    // Override to always return false
    return false; // Boolean
  },
});
